import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import { TYPES } from './private';

export interface IA2HSState {
    appIconUrl: string;
    heading: ITextProps;
    subheading: ITextProps;
}

export interface ITextProps {
    text: string;
    fontFamily: string;
    fontSize: string;
    fontWeight: number;
    color: string;
    visible: boolean;
}

export interface IA2HS {
    renderer: () => JSX.Element | null;
    setSiteName: (newName: string) => void;
}

export function injectA2HS(container: IContainer = injectOrBuildContainer()): IA2HS {
    return container.get<IA2HS>(TYPES.IA2HS);
}

export function bindA2HS(A2HS: IA2HS, container: IContainer = injectOrBuildContainer()): void {
    container.bind<IA2HS>(TYPES.IA2HS, A2HS);
}

export function unbindA2HS(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IA2HS);
}
